import { Discipline, Participant } from "../api/Dtos";

const disciplinesWithStartnumbers = new Set(["H", "HL"]);

export function buildStartgroupDisciplineLabels(
  disciplines: Array<Discipline>,
  participants: Array<Participant>
) {
  const participantStartnumbersByKey = participants.reduce<
    Record<string, Array<number>>
  >((accumulator, participant) => {
    if (
      participant.startgroupId == null ||
      participant.startnumber == null ||
      !disciplinesWithStartnumbers.has(participant.disciplineName)
    ) {
      return accumulator;
    }

    const key = `${participant.startgroupId}:${participant.disciplineName}`;
    const current = accumulator[key] ?? [];
    accumulator[key] = [...current, participant.startnumber];
    return accumulator;
  }, {});

  return disciplines.reduce<Record<number, Array<string>>>(
    (accumulator, discipline) => {
      discipline.startgroups.forEach((startgroup) => {
        const existing = accumulator[startgroup.id] ?? [];
        const key = `${startgroup.id}:${discipline.name}`;
        const startnumbers = participantStartnumbersByKey[key] ?? [];
        const label = shouldShowStartnumbers(discipline.name, startnumbers)
          ? `${discipline.name} (${sortStartnumbers(startnumbers).join(", ")})`
          : discipline.name;

        accumulator[startgroup.id] = [...existing, label];
      });

      return accumulator;
    },
    {}
  );
}

function shouldShowStartnumbers(
  disciplineName: string,
  startnumbers: Array<number>
) {
  return disciplinesWithStartnumbers.has(disciplineName) && startnumbers.length > 0;
}

function sortStartnumbers(startnumbers: Array<number>) {
  return [...startnumbers].sort((left, right) => left - right);
}